import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { RedirectService } from "@core/services/redirect.service";
import { assetUrl } from "@shared/helper/asset-url";

@Component({
  selector: "app-platform-news-modal",
  templateUrl: "./platform-news-modal.component.html",
  styleUrls: ["./platform-news-modal.component.scss"],
  standalone: false
})
export class PlatformNewsModalComponent {
  imageBannerPath: string = assetUrl("images/temp/banner_driveb_agosto.png");

  constructor(
    private matDialogRef: MatDialogRef<PlatformNewsModalComponent>,
    private redirectService: RedirectService
  ) {}

  closeDialog(): void {
    this.matDialogRef.close();
  }

  redirectToServiceRequest(): void {
    this.closeDialog();
    this.redirectService.redirectToServiceRequest();
  }
}
